module.exports = __webpack_public_path__ + "static/media/cronometer.75fc83f7.svg";